

export namespace Uri
{
    export function join(...segments: string[]): string
    {
        if (segments.length < 1)
            return "";

        const base = segments.shift()!;

        let [location, scheme] = base.split("://").reverse();
        location = location?.replace(/\\/g, "/");

        const baseSegments = location?.split('/');
        const hostname =
            (scheme != null)
                ? baseSegments.shift()
                : null;

        segments =
            [
                ...baseSegments,
                ...segments
                    .map(segment => segment.replace(/\\/g, "/"))
                    .map(segment => segment.split('/'))
                    .flat()
            ];
        segments = segments.filter(segment => !!segment);

        const result: string[] = [];
        segments.forEach(
            segment =>
            {
                if (segment == ".")
                    return;
                else if (segment == "..")
                    return result.pop();
                else
                    result.push(segment);
            }
        );

        let uri = "";
        if (scheme != null || hostname != null)
            uri = `${scheme ?? ""}://`;

        if (hostname != null)
            uri += `${hostname}/`;

        uri += result.join('/');

        return uri;
    }

    export function normalize(uri: string): string
    {
        return uri.replace(/\\/g, '/');
    }
}
